// src/App.js — Main app with routing
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import Login        from './pages/Login';
import Register     from './pages/Register';
import Dashboard    from './pages/Dashboard';
import MyAttendance from './pages/MyAttendance';
import MyLeave      from './pages/MyLeave';
import MyWfh        from './pages/MyWfh';
import Corrections  from './pages/Corrections';
import TeamView     from './pages/TeamView';
import Approvals    from './pages/Approvals';
import Employees    from './pages/Employees';
import Holidays     from './pages/Holidays';
import Settings     from './pages/Settings';
import Reports      from './pages/Reports';
import Layout       from './components/Layout';

// Route guard — redirect to login if not authenticated
const PrivateRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          {/* Public routes */}
          <Route path="/login"    element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected routes — all wrapped in Layout (sidebar + header) */}
          <Route path="/" element={
            <PrivateRoute><Layout /></PrivateRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="attendance"  element={<MyAttendance />} />
            <Route path="leave"       element={<MyLeave />} />
            <Route path="wfh"         element={<MyWfh />} />
            <Route path="corrections" element={<Corrections />} />

            {/* Manager + Admin */}
            <Route path="team" element={
              <PrivateRoute roles={['admin','manager']}><TeamView /></PrivateRoute>
            }/>
            <Route path="approvals" element={
              <PrivateRoute roles={['admin','manager']}><Approvals /></PrivateRoute>
            }/>

            {/* Admin only */}
            <Route path="employees" element={
              <PrivateRoute roles={['admin']}><Employees /></PrivateRoute>
            }/>
            <Route path="holidays" element={
              <PrivateRoute roles={['admin']}><Holidays /></PrivateRoute>
            }/>
            <Route path="settings" element={
              <PrivateRoute roles={['admin']}><Settings /></PrivateRoute>
            }/>
            <Route path="reports" element={
              <PrivateRoute roles={['admin','manager']}><Reports /></PrivateRoute>
            }/>
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
